import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import ChatInterface from './components/ChatInterface';
import ParticleBackground from './components/ParticleBackground';
import N2NAnalytics from './components/N2NAnalytics';
import QQAnalytics from './components/QQAnalytics';
import QQPixelAnalytics from './components/QQPixelAnalytics';
import QQClarity from './components/QQClarity';
import N2NClarity from './components/N2NClarity';
import services from './serviceConfig';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App">
          <ParticleBackground />
          <Routes>
            <Route
              path="/qq/*"
              element={
                <>
                  <QQAnalytics />
                  <QQPixelAnalytics />
                  <QQClarity />
                  <ChatInterface key="qq" service={services.qq} />
                </>
              }
            />
            <Route
              path="/n2n/*"
              element={
                <>
                  <N2NAnalytics />
                  <N2NClarity />
                  <ChatInterface key="n2n" service={services.n2n} />
                </>
              }
            />
            <Route path="*" element={<ChatInterface key="selector" />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
